import React from 'react';
import TOJoinNowView from '../Views/TO/Login/JoinNowView';

import AppVars from '../../AppVars.js'
import Logger from '../../Logger.js';

import {setCookies} from "account-portal-library/lib/helperFunctions";

let appVars = AppVars.getInstance();
let logger = Logger.getInstance();


class JoinNow extends React.Component {
  constructor(props){
    super(props);
    this.state = {
    }
  }

  saveURI(){
    logger.log('stage', this.state.style)
    if (this.state.style === "DG"){
      setCookies("login_uri", window.location.href, "/", appVars.getDomain())
    }
    // window.location.replace(appVars.getResendActivationEmailURL(this.state.style))
  }

  render(){
    return(
        <TOJoinNowView 
        username = {this.props.username}
        style = {this.props.style}
        saveURI = {this.saveURI}
        />
        



);

}

}

export default JoinNow;